<template>
    <div>
        <h1>{{ $t("admin.adminPolicyView.header") }}</h1>
        <form id="search" @submit="updatePolicy">
            <label for="policyName">{{ $t("admin.adminPolicyView.policyName") }}: </label><input id="policyName" name="policyName" v-model="policyName"><br/>
            <label for="policyDescription">{{ $t("admin.adminPolicyView.policyDescription") }}: </label><textarea id="policyDescription" name="policyDescription" v-model="policyDescription"></textarea><br/>

        <table class="datatable">
            <caption class="caption">Policy detail table</caption>
            <tr>
                <th scope="col">{{ $t("admin.adminPolicyView.table.module") }}</th>
                <th scope="col">{{ $t("admin.adminPolicyView.table.function") }}</th>
            </tr>
            <tr v-for="(policy, index) in policyData" v-bind:key="index">
                <td v-if="index == 0">
                    <label><input id="moduleEnabled" name="moduleEnabled" v-model="policy.moduleEnabled" type="checkbox">{{ policy.moduleName }}</label>
                </td>
                <td v-else-if="!(policy.moduleId == policyData[index - 1].moduleId)">
                    <label><input id="moduleEnabled" name="moduleEnabled" v-model="policy.moduleEnabled" type="checkbox">{{ policy.moduleName }}</label>
                </td>
                <td v-else>
                </td>
                <td>
                    <label><input id="functionEnabled" name="functionEnabled" v-model="policy.functionEnabled" type="checkbox">{{ policy.functionName }}</label>
                </td>
            </tr>
        </table>

            <input type="submit" class="submit" v-bind:value="$t('admin.adminPolicyView.button.update')">
        </form>
        <AdminPolicyDelete v-bind:policy="policyData" />

    <hr/>
    <div v-if="attachedPlanList">
        <h2>{{ $t("admin.adminPolicyView.planListTable.header") }}</h2>
        <table v-if="attachedPlanList" class="datatable">
            <caption class="caption">attached plan list table</caption>
            <tr>
                <th scope="col">{{ $t("admin.adminPolicyView.planListTable.planName") }}</th>
                <th scope="col">{{ $t("admin.adminPolicyView.planListTable.enabled") }}</th>
            </tr>
            <tr v-for="(plan, index) in attachedPlanList" v-bind:key="index">
                <td><router-link :to="'/admin/planView/' + plan.id">{{ plan.name }}</router-link></td>
                <td>{{ plan.enabled ? $t("common.yes") : $t("common.no") }}</td>
            </tr>
        </table>
    </div>
</div>
</template>

<script>
    import { adminService } from '@/services/admin.service'
    import AdminPolicyDelete from "./AdminPolicyDelete";
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/locale/ja';

    export default {
        name: 'AdminPolicyView',
        components: {
            AdminPolicyDelete,
        },
        data: function() {
            return {
                policyData: {},
                policyName: '',
                policyDescription: '',
                updatePolicyData: [],
                attachedPlanList: []
            }
        },
        created: function() {
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                return new Promise(async (resolve) => {
                    await adminService.policyGet(this.$route.params.policyId).then((data) => {
                        this.policyData = data
                        this.policyName = data[0].policyName

                        if(data[0].policyDescription){
                            this.policyDescription = decodeURIComponent(atob(data[0].policyDescription))
                        }
                    });
                    await adminService.planGetAttachedPolicy(this.$route.params.policyId).then((data) => {
                        this.attachedPlanList = data;
                    });
                    resolve();
                }).catch((err) => {
                    console.error('Unable to get policy view: ', err)
                })
            },
            updatePolicy: function(e) {
                e.preventDefault();
                this.updatePolicyData.splice(0, this.updatePolicyData.length)
                
                for (let p of this.policyData){
                    p.policyName = this.policyName
                    p.policyDescription = this.policyDescription

                    this.updatePolicyData.push({
                        policyId: p.policyId,
                        policyName: p.policyName,
                        policyDescription: btoa(encodeURIComponent(this.policyDescription)),
                        planId: p.planId,
                        moduleId: p.moduleId,
                        moduleName: p.moduleName,
                        moduleEnabled: p.moduleEnabled,
                        functionId: p.functionId,
                        functionName: p.functionName,
                        functionEnabled: p.functionEnabled
                    })
                }

                let tmpPolicyData = JSON.parse(JSON.stringify(this.updatePolicyData));

                adminService.policyUpdate(this.$route.params.policyId, tmpPolicyData).then(() => {
                    this.fetchData();
                }).catch((err) => {
                    console.error('Unable to update policy: ', err)
                })
            }
        }
    }
</script>
